import ChatButton from '../ChatButton/ChatButton'
import CommentListComponent from '../CommentListComponent'
import './style.less'

import {
  filter,
  find,
  forEach,
  forIn,
  get,
  groupBy,
  isEmpty,
  map,
  omit,
  pick,
  size,
  values,
} from 'lodash'
import {
  COMMENT_INSPECTION,
  COMMENT_INSPECTION_SUMMARY,
  mockTitle,
} from '@/screens/QSF/Inspection/Inspection.constant'

interface Props {
  displayType?: 'checkpoint' | ''
  dataSource?: {}
}

function InspectionCommentListComponent(props: Props) {
  const { dataSource = {}, displayType = '' } = props

  const commentNotInSectionsData = get(dataSource, 'comments', [])
  const sectionCommentsData = get(dataSource, 'sections', [])
  const checkpointComments = get(dataSource, 'comments', [])

  const commentGroupByType = groupBy(commentNotInSectionsData, 'comment_type')
  const hasSectionComments = !isEmpty(checkpointComments)

  //  return null to prevent rendering the component.
  if (!hasSectionComments) {
    return null
  }

  const groupBySeparateComments = pick(commentGroupByType, [
    COMMENT_INSPECTION,
    COMMENT_INSPECTION_SUMMARY,
  ])

  //   SECTION HEADER
  const renderCommentHeader = () => {
    return (
      <div className="comment-header">
        <ChatButton showIcon={false} onClick={() => {}} />
        <p className="label-title">Comments</p>
      </div>
    )
  }

  /**
   * Render Comment in Inspection Overall and Inspection Summary
   * @param inspectionComment
   * @returns
   */
  const renderSeparateComments = (inspectionComment = []) => {
    if (isEmpty(inspectionComment)) {
      return <></>
    }

    const renderCommentList = (item, index) => {
      const title = mockTitle[`${index}`]

      return (
        <div className="comment-content">
          <p className="comment-section-title">{title}</p>
          <CommentListComponent dataSource={item} />
        </div>
      )
    }
    const testResult = map(groupBySeparateComments, renderCommentList)
    return <div className="comment-body">{testResult}</div>
  }

  const renderSubSectionCommentList = (data) => {
    // const subSectionComments = get(subSectionData, 'comments', [])

    const renderComment = (item, index) => {
      let element = document.getElementById(item.id)
      const scrollToView = () => {
        if (element) element.scrollIntoView({ behavior: 'smooth' })
      }
      const parentDisplayOrder = get(item, 'parent.display_order')
      const subSectionDisplayOrder = get(item, 'display_order')
      const subSectionTitle = get(item, 'title', '')
      const title = `${parentDisplayOrder + 1}.${
        subSectionDisplayOrder + 1
      } ${subSectionTitle}`
      const subSectionComments = get(item, 'comments', [])
      const sizeSubSectionComments = size(subSectionComments)

      if (!sizeSubSectionComments) {
        return <></>
      }

      return (
        <div>
          <p className="comment-sub-section-title" onClick={scrollToView}>
            {title}
          </p>
          {sizeSubSectionComments && (
            <CommentListComponent dataSource={subSectionComments} />
          )}
        </div>
      )
    }
    const renderSubSection = map(data, renderComment)

    return <div>{renderSubSection}</div>
  }

  const renderCheckpointComment = (checkpointData = {}) => {
    const comments = get(checkpointData, 'comments', [])
    if (!size(checkpointComments)) {
      return null
    }

    return (
      <div className="comment-body">
        <div className="comment-content">
          <CommentListComponent dataSource={comments} />
        </div>
      </div>
    )
  }

  const renderSectionsComments = (sectionData = []) => {
    if (isEmpty(sectionData)) {
      return <></>
    }

    const groupBySubSection = groupBy(sectionData, 'parent.id')
    const renderSectionCommentList = (item, index) => {
      let element = document.getElementById(item[0].id)
      const scrollToView = () => {
        if (element) element.scrollIntoView({ behavior: 'smooth' })
      }
      const sectionComments = get(item, '[0].comments', [])
      const sizeSectionComments = !!size(sectionComments)
      const sectionDisplayOrder = get(item, '[0].display_order')
      const sectionTitle = get(item, '[0].title', '')
      const title = `${sectionDisplayOrder + 1}. ${sectionTitle}`
      const subSectionData = groupBySubSection[`${index}`] || {}
      const sizeSubSectionComments = find(
        subSectionData,
        (sI: any) => !!size(sI.comments)
      )

      // Skip rendering if there are no section or sub-section comments
      if (!sizeSectionComments && !sizeSubSectionComments) {
        return null
      }

      return (
        <div className="comment-content">
          <p className="comment-section-title" onClick={scrollToView}>
            {title}
          </p>
          {sizeSectionComments && (
            <CommentListComponent dataSource={sectionComments} />
          )}
          {renderSubSectionCommentList(subSectionData)}
        </div>
      )
    }
    const groupBySection = omit(
      groupBy(sectionData, (item) => (!item.parent ? item.id : undefined)),
      'undefined'
    )

    const renderSection = map(groupBySection, renderSectionCommentList)
    return <div className="comment-body">{renderSection}</div>
  }

  let renderByLayoutType = <></>
  if (displayType === 'checkpoint') {
    renderByLayoutType = <>{renderCheckpointComment(dataSource)}</>
  } else {
    renderByLayoutType = (
      <>
        {renderSeparateComments(commentNotInSectionsData)}
        {renderSectionsComments(sectionCommentsData)}
      </>
    )
  }

  return (
    <div className="report-comment-container">
      <div className="wrap-content">
        {renderCommentHeader()}
        {renderByLayoutType}
      </div>
    </div>
  )
}

export default InspectionCommentListComponent
